<template>
  <div v-loading="loading">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('lang.IOControl.universal')" name="currency">
        <el-button type="primary" size="mini" style="float: right;" @click="refreshClick">{{
          $t("lang.IOControl.refresh") }}</el-button>
        <div class="col">
          <p>{{ $t("lang.IOControl.DIDigitalInput") }}</p>
          <el-table :data="diio">
            <el-table-column prop="name" :label="$t('lang.IOControl.deviceName')" align="center">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.name"
                  :placeholder="$t('lang.IOControl.pleaseDeviceName')"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="device" :label="$t('lang.IOControl.interfaceName')" align="center">
            </el-table-column>
            <el-table-column prop="value" :label="$t('lang.IOControl.deviceState')" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.value === "启用"
                    ? $t("lang.IOControl.enable")
                    : $t("lang.IOControl.disable")
                }}
              </template>
            </el-table-column>
            <el-table-column align="center">
              <!-- <template slot-scope="scope">
                <el-button size="mini" @click="btnClick(scope.row)">{{
                  scope.row.value === "启用" ? "关闭" : "打开"
                }}</el-button>
              </template> -->
            </el-table-column>
          </el-table>
        </div>
        <div class="col">
          <p>{{ $t("lang.IOControl.DODigitalInput") }}</p>
          <el-table :data="doio">
            <el-table-column prop="name" :label="$t('lang.IOControl.deviceName')" align="center">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.name"
                  :placeholder="$t('lang.IOControl.pleaseDeviceName')"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="device" :label="$t('lang.IOControl.interfaceName')" align="center">
            </el-table-column>
            <el-table-column prop="value" :label="$t('lang.IOControl.deviceState')" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.value === "启用"
                    ? $t("lang.IOControl.enable")
                    : $t("lang.IOControl.disable")
                }}
              </template>
            </el-table-column>
            <el-table-column prop="value" :label="$t('lang.IOControl.start_stop')" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="btnClick(scope.row)">{{
                  scope.row.value === "启用"
                    ? $t("lang.ConfigSetting.Disable")
                    : $t("lang.ConfigSetting.Enable")
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col">
          <p>{{ $t("lang.IOControl.relay") }}</p>
          <el-table :data="rlio">
            <el-table-column prop="name" :label="$t('lang.IOControl.deviceName')" align="center">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.name"
                  :placeholder="$t('lang.IOControl.pleaseDeviceName')"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="device" :label="$t('lang.IOControl.interfaceName')" align="center">
            </el-table-column>
            <el-table-column prop="value" :label="$t('lang.IOControl.deviceState')" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.value === "启用"
                    ? $t("lang.IOControl.enable")
                    : $t("lang.IOControl.disable")
                }}
              </template>
            </el-table-column>
            <el-table-column prop="value" :label="$t('lang.IOControl.start_stop')" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="btnClick(scope.row)">{{
                  scope.row.value === "启用"
                    ? $t("lang.ConfigSetting.Disable")
                    : $t("lang.ConfigSetting.Enable")
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('lang.IOControl.senior')" name="senior">
        <p>{{ $t("lang.IOControl.seniorConfig") }}</p>
        <el-form :model="senior" label-width="200px">
          <el-form-item :label="$t('lang.IOControl.trueOn')">
            <el-checkbox v-model="senior.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('lang.IOControl.debug')">
            <el-checkbox v-model="senior.enable_debug"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('lang.IOControl.logNumber')">
            <el-input size="mini" v-model="senior.log_file_num" style="width:190px;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.IOControl.logSize')">
            <el-input size="mini" v-model="senior.log_file_size" style="width:190px;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.IOControl.logPriority')">
            <el-select v-model="senior.log_priority" size="mini">
              <el-option :label="$t('lang.IOControl.debug')" value="8"></el-option>
              <el-option :label="$t('lang.IOControl.info')" value="7"></el-option>
              <el-option :label="$t('lang.IOControl.notice')" value="6"></el-option>
              <el-option :label="$t('lang.IOControl.warn')" value="5"></el-option>
              <el-option :label="$t('lang.IOControl.error')" value="4"></el-option>
              <el-option :label="$t('lang.IOControl.fatal')" value="3"></el-option>
              <el-option :label="$t('lang.IOControl.alert')" value="2"></el-option>
              <el-option :label="$t('lang.IOControl.urgent')" value="1"></el-option></el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.IOControl.logFile')">
            <el-button size="mini" @click="downClick" type="danger">{{
              $t("lang.IOControl.download")
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <div style="float: right;margin-top: 20px;">
      <el-button type="danger" @click="saveClick">{{
        $t("lang.IOControl.SaveApply")
      }}</el-button>
    </div>
  </div>
</template>

<script>
import { listConfig, getLog, updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import { cloneDeep, isEqual } from "lodash";
export default {
  name: "ioControl",
  props: ["deviceDid", "deviceSn"],
  data() {
    return {
      diio: [],
      doio: [],
      rlio: [],
      diioClone: [],
      doioClone: [],
      rlioClone: [],
      activeName: "currency",
      senior: {
        enabled: true,
        enable_debug: false,
        log_file_num: "",
        log_file_size: "",
        log_priority: "",
      },
      seniorClone: {},
      loading: true,
    };
  },
  async mounted() {
    await this.getData();
    this.loading = false;
  },
  methods: {
    getData() {
      return new Promise((reslove, reject) => {
        listConfig(this.deviceSn, this.deviceDid, [
          {
            config: "smartioc",
            section: "device",
            options: [
              {
                option: "name",
              },
              {
                option: "type",
              },
              {
                option: "device",
              },
              {
                option: "value",
              },
            ],
          },
          {
            config: "smartioc",
            section: "service",
            options: [
              {
                option: "enabled",
              },
              {
                option: "enable_debug",
              },
              {
                option: "log_file_num",
              },
              {
                option: "log_file_size",
              },
              {
                option: "log_priority",
              },
            ],
          },
        ]).then((res) => {
          this.diio = [];
          this.doio = [];
          this.rlio = [];
          let config = res.data.data.mess[0].s_objects;
          config.forEach((item) => {
            switch (item.options.type) {
              case "di":
                this.diio.push({
                  name: item.options.name,
                  device: item.options.device,
                  value: item.options.value == 1 ? "启用" : "关闭",
                  index: item.index,
                });
                break;
              case "do":
                this.doio.push({
                  name: item.options.name,
                  device: item.options.device,
                  value: item.options.value == 1 ? "启用" : "关闭",
                  index: item.index,
                });
                break;
              case "rl":
                this.rlio.push({
                  name: item.options.name,
                  device: item.options.device,
                  value: item.options.value == 1 ? "启用" : "关闭",
                  index: item.index,
                });
                break;
            }
          });
          let senior = res.data.data.mess[1].s_objects[0].options;
          this.senior = {
            enabled: senior.enabled == 1 ? true : false,
            enable_debug: senior.enable_debug == 1 ? true : false,
            log_file_num: senior.log_file_num,
            log_file_size: senior.log_file_size,
            log_priority: senior.log_priority,
          };
          this.diioClone = cloneDeep(this.diio);
          this.doioClone = cloneDeep(this.doio);
          this.rlioClone = cloneDeep(this.rlio);
          this.seniorClone = cloneDeep(this.senior);
          reslove();
        });
      });
    },
    downClick() {
      getLog({
        did: this.deviceDid,
        sn: this.deviceSn,
        mess: "smartioc",
      }).then((res) => {
        const { data } = res;
        // 创建Blob对象（类文件对象）
        const blob = new Blob([data]);
        // let disposition = decodeURI(res.headers['content-disposition'])
        // 从响应头中获取文件名
        // let filename = disposition.substring(disposition.indexOf('fileName=') + 9, disposition.length)
        if ("download" in document.createElement("a")) {
          // 非IE下载
          // 创建隐藏下载超链接
          const elink = document.createElement("a");
          // 使用超链接的download属性下载文件
          elink.download = this.$t("lang.IOControl.logFile");
          elink.style.display = "none";
          // 使用Blob创建一个指向类型化数组的URL
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          // 自定点击超链接
          elink.click();
          // 释放URL对象
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          //IE10+下载
          navigator.msSaveBlob(blob, filename);
        }
      });
    },
    saveClick() {
      this.loading = true;
      let dataList = [];
      this.diio.forEach((item) => {
        dataList.push({
          config: "smartioc",
          section: "device",
          action: 0,
          index: [item.index],
          options: { name: item.name },
        });
      });
      this.doio.forEach((item) => {
        dataList.push({
          config: "smartioc",
          section: "device",
          action: 0,
          index: [item.index],
          options: { name: item.name },
        });
      });
      this.rlio.forEach((item) => {
        dataList.push({
          config: "smartioc",
          section: "device",
          action: 0,
          index: [item.index],
          options: { name: item.name },
        });
      });
      updateConfig(this.deviceSn, this.deviceDid, [
        ...dataList,
        {
          config: "smartioc",
          section: "service",
          action: 0,
          index: [0],
          options: {
            enabled: this.senior.enabled ? 1 : 0,
            enable_debug: this.senior.enable_debug ? 1 : 0,
            log_file_num: this.senior.log_file_num,
            log_file_size: this.senior.log_file_size,
            log_priority: this.senior.log_priority,
          },
        },
      ]).then(async (res) => {
        if (res.data.data.mess == 0) {
          if (
            isEqual(this.diio, this.diioClone) ||
            isEqual(this.doio, this.doioClone) ||
            isEqual(this.rlio, this.rlioClone) ||
            isEqual(this.senior, this.seniorClone)
          ) {
            await this.restart();
            this.$message({
              type: "success",
              message: this.$t("lang.IOControl.editSuccess"),
            });
          } else {
            this.$message({
              type: "success",
              message: this.$t("lang.IOControl.editSuccess"),
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: this.$t("lang.IOControl.editSuccess"),
          });
        }
        await this.getData();
        this.loading = false;
      });
    },
    btnClick(e) {
      if (!this.senior.enabled) {
        return this.$message({
          type: "warning",
          message: this.$t("lang.IOControl.msg1"),
        });
      }
      this.loading = true;
      e.value == "启用" ? (e.value = "关闭") : (e.value = "启用");
      progressControl(
        [
          {
            process: "smartioc",
            action: `${e.device} ${e.value == "启用" ? '1' : '0'}`,
            type: 2,
          },
        ],
        this.deviceDid,
        this.deviceSn
      ).then(async (res) => {
        if (e.device.indexOf("do") != -1) {
          let dataList = [];
          this.doio.forEach((item) => {
            dataList.push({
              config: "smartioc",
              section: "device",
              action: 0,
              index: [item.index],
              options: { value: item.value == "启用" ? "0" : "1" },
            });
          });
          // await updateConfig(this.deviceSn, this.deviceDid, [...dataList]);
        } else if (e.device.indexOf("relay") != -1) {
          let dataList = [];
          this.rlio.forEach((item) => {
            dataList.push({
              config: "smartioc",
              section: "device",
              action: 0,
              index: [item.index],
              options: { value: item.value == "启用" ? "0" : "1" },
            });
          });
          // await updateConfig(this.deviceSn, this.deviceDid, [...dataList]);
        }
        await this.getData();
        this.loading = false;
        if (res.data.data.mess == 0) {
          this.$message({
            type: "success",
            message: this.$t("lang.IOControl.msgok"),
          });
        } else {
          this.$message({
            type: "warning",
            message: this.$t("lang.IOControl.msgfaile"),
          });
        }
      });
    },
    //刷新数据
    async refreshClick() {
      this.loading = true;
      await this.getData();
      this.loading = false;
    },
    restart() {
      return new Promise((reslove, reject) => {
        progressControl(
          [{ process: "smartioc", action: "restart", type: 0 }],
          String(this.deviceDid),
          this.deviceSn
        ).then((res) => {
          reslove();
        });
      });
    },
  },
};
</script>
<style scoped>
.col {
  margin-top: 10px;
}
</style>
